import React from 'react';
import { connect } from 'react-redux';
import Input from 'react-toolbox/lib/input';
import { Button, IconButton } from 'react-toolbox/lib/button';
import Autocomplete from 'react-toolbox/lib/autocomplete';
import { updateArticle } from '~/actions/locations';
import styleDialog from '~/style/dialog.scss';

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    const conf = props.data || {};
    this.state = {
      article: conf.article || '',
      location: conf.location || '',
      count: conf.count || 0,
    };
  }

  update() {
    updateArticle(
      this.props.dispatch,
      this.context.apiClient,
      this.state.location,
      this.state.article,
      this.state.count
    )
      .then(() => this.context.dialogClose(this.props.dialogId));
  }

  render() {
    return (
      <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
          <div className={styleDialog.content}>
            <form onSubmit={e => { e.preventDefault(); this.update(); }}>
              <Autocomplete
                required
                label="Select Article"
                onChange={article => this.setState({ article })}
                source={this.props.articles}
                value={this.state.article}
                multiple={false}
              />
              <Autocomplete
                required
                label="Select Location"
                onChange={location => this.setState({ location })}
                source={this.props.locations}
                value={this.state.location}
                multiple={false}
              />
              <Input required label="Count" type="number" value={this.state.count} onChange={count => this.setState({ count: parseInt(count, 10) })} />
              <Button label="Update" type="submit" primary raised />
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  articles: Object.values(state.getIn(['articles', 'articles']).toJS())
    .reduce((s, v) => ({ ...s, [v.id]: v.name }), {}),
  locations: Object.values(state.getIn(['locations', 'locations']).toJS())
    .reduce((s, v) => ({ ...s, [v.id]: v.name }), {}),
});

export default connect(mapStateToProps)(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/ArticleLocationSet/index.js